export const NAME = "reportSettingsModalView"
export const FORM_NAME = `${NAME}/reportSettingsModalFormViewModalForm`
